/*
  Значения протокола собрания без разметки: пустой протокол, строка «в заявлении
  будет так», проверка пустоты и тело запроса. Вынесено из `ProtocolStep.jsx`
  21.10.2026, когда окну понадобился второй путь - сверка скана
  (`ProtocolScanCheck.jsx`): оба импортировали бы друг друга по кругу.
*/

const MONTHS = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
]

export const EMPTY_PROTOCOL = { protocol_number: '', protocol_date: '' }

/*
  Строка протокола так, как её печатает заявление: «протокол № 2 от 18 марта
  2019 г.». Повторяет `court_order_values._protocol_text` на сервере - это
  предпросмотр, а не второй источник: в документ уходит серверный текст.
*/
export function protocolPreview({ protocol_number: number, protocol_date: when }) {
  // Пусто всё - заготовка. Иначе - ровно то, что напечатает сервер: без номера
  // только дата, без даты только номер (21.10.2026, ревью: протокол без номера -
  // основной случай образца заказчика, а предпросмотр печатал «протокол № …»).
  if (!number.trim() && !when) return 'протокол № … от …'
  const parts = []
  if (number.trim()) parts.push(`протокол № ${number.trim()}`)
  if (when) {
    const [year, month, day] = when.split('-')
    parts.push(`от ${Number(day)} ${MONTHS[Number(month) - 1]} ${year} г.`)
  }
  return parts.join(' ')
}

export function isEmptyProtocol(values) {
  return !values.protocol_number.trim() && !values.protocol_date
}

export function protocolBody(values) {
  return {
    protocol_number: values.protocol_number.trim() || null,
    protocol_date: values.protocol_date || null,
  }
}
